import './instrument';
// Before anything else: if Firebase left a live session in this browser, start the profile
// and product requests now rather than after the SDK's own account lookup.
import { startEarlySession } from '@features/auth/earlySession';
startEarlySession();
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './main.css';

// Build marker: confirms which build a preview/deploy is serving.
console.info(`[dealer] build ${import.meta.env.VITE_ENV ?? 'local'} (monorepo apps/dealer)`);
import DefaultErrorFallback from '@components/Fallbacks/DefaultErrorFallback';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import ceil from './utils/daysjsExtenders/ceil';
import floor from './utils/daysjsExtenders/floor';
import round from './utils/daysjsExtenders/round';

dayjs.extend(advancedFormat);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(weekday);
dayjs.extend(ceil);
dayjs.extend(floor);
dayjs.extend(round);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* <Sentry.ErrorBoundary fallback={<DefaultErrorFallback message='Unexpected error caught at main.tsx' />}> */}
    <App />
    {/* </Sentry.ErrorBoundary> */}
  </React.StrictMode>
);
